// Depends on components/embeds/embed-youtube-api.js to preload the youtbe API
// TODO: Global variables are bad. We should clean this. Check video-entry.js
var youtubeplayer;

function onYoutubePlayerStateChangeVideoEntry(newState) {
   if (newState.data === YT.PlayerState.ENDED){
		var published_date = $("#ytplayer").data("published");
    	var videovertical = $("#ytplayer").data("videovertical");
    	get_next_video(published_date, videovertical);
    }
}
